import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { ResponseRawErrorT } from "@/models";
import { axiosInstanceNamek } from "@/service/Axios";
import type { GreenCenterMaterials } from "@/service/namek/useGetMaterialsByCVId";

import { ASSIGN_MATERIALS_KEYS as KEYS } from "./queryKeys";

const getAllAssignMaterials = () => {
  return axiosInstanceNamek
    .get<void, AxiosResponse<GreenCenterMaterials[]>>(`v1/GreenCenters/materials`, {
      params: {
        orderBy: "greenCenter",
        orderDirection: "asc",
      },
    })
    .then((response) => response.data);
};

export function useGetAllAssignMaterials() {
  return useQuery<GreenCenterMaterials[], ResponseRawErrorT>({
    queryFn: () => getAllAssignMaterials(),
    queryKey: [KEYS.RECORDS],
    retry: 0,
  });
}
